import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';


import { loginReducer } from '../login/reducer';
import language from "./language/reducer";
//import { reducer as toastrReducer } from 'react-redux-toastr'

import refreshTokenMiddleware from './middleware/refreshMiddleware';
import { myInfoReducer } from '../myprofile/myinfo/reducer';
import { mySpecialtyReducer } from '../myprofile/myspecialty/reducer';
import { refreshReducer } from '../refreshToken/reducer';
//import { myPortfolioReducer } from '../myprofile/myportfolio/reducer';
import { registerReducer } from '../register/registerSimple/reducer';
//import { registerCustomerReducer } from '../register/registerCustomer/reducer';
//import { registerExecutorReducer } from '../register/registerExecutor/reducer';
import { verifyAccountReducer } from '../verify/reducer';
import { myElementsReducer } from '../myprofile/myelements/reducer';
import { regionsReducer } from '../regions/reducer';
import { createProjectReducer } from '../projects/newproject/reducer';
import { myProjectsReducer } from '../projects/myprojects/reducer';
//import { projectDetailsReducer } from '../projects/projectdetails/reducer';
import { executerReducer } from '../projects/executerdetails/reducer';
//import { projectsExecuterReducer } from '../projectsExecuter/reducer';
import { chatReducer } from '../chat/reducer';
import { feedbackReducer } from '../feedback/reducer';
import { homeReducer } from '../home/reducer';
import { editorSessionsReducer } from './../myprofile/editorSessions/reducer';
import { goodsReducer as myGoodsReducer } from '../myprofile/goods/reducer'
import { goodsReducer } from '../goods/reducer'
import { calculationFactorsReducer } from '../myprofile/calculationfactors/reducer';
import { favoriteReducer } from '../favorites/reducer';
import { instructionsReducer } from '../instruction/reducer';
import { basketReducer } from '../basket/reducer';
import { autoBuildEditReducer } from '../autoBuildEdit/reducer';
import { autoBuildReducer } from '../autoBuild/reducer';
import { elementsReducer } from '../elements/reducer';
import { solutionsReducer } from '../solutions/reducer';
import { balanceReducer } from '../myprofile/balance/reducer';
import { embeddingReducer } from '../embedding/reducer';
import { siteCompanyReducer } from '../siteCompany/reducer';
import { manufacturerReducer } from '../manufacturer/reducer';
import { calculatorReducer } from '../calculator/reducer';
import { myProjects3Reducer } from '../projects/myprojectsv3/reducer';
import { sitePortfolioReducer } from '../myprofile/sitePortfolio/reducer';
import { elementMatchReducer } from '../myprofile/elementmatch/reducer';
import { editUserProductReducer } from '../myprofile/myproductportfolio/reducer';
import { toastrReducer } from '../components/toastr/reducer';
import { questionnairePTReducer } from '../questionnairePT/reducer';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
export const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;


function configureStore(history, initialState) {
    const reducers = {        
        // signup,
        home: homeReducer,
        login: loginReducer,
        language,
        // myprofile,
        toastr: toastrReducer,
        myInfo: myInfoReducer,
        mySpecialty: mySpecialtyReducer,
        refreshToken: refreshReducer,
        //myportfolio: myPortfolioReducer,
        //registerCustomer: registerCustomerReducer,
        //registerExecutor: registerExecutorReducer,
        register: registerReducer,
        verifyAccount: verifyAccountReducer,
        myElements: myElementsReducer,
        regions: regionsReducer,
        createProject: createProjectReducer,
        myProjects: myProjectsReducer,
        //projectDetails: projectDetailsReducer,
        executerDetails: executerReducer,
        //projectsExecuter: projectsExecuterReducer,
        chat: chatReducer,
        feedback: feedbackReducer,
        editorSessions: editorSessionsReducer,
        calculationFactors: calculationFactorsReducer,
        favorite: favoriteReducer,
        mygoods: myGoodsReducer,
        goods: goodsReducer,
        basket: basketReducer,
        instructions: instructionsReducer,
        autoBuildEdit: autoBuildEditReducer,
        autoBuild: autoBuildReducer,
        solutions: solutionsReducer,
        elements: elementsReducer,
        balance: balanceReducer,
        embedding: embeddingReducer,
        siteCompany: siteCompanyReducer,
        manufacturer: manufacturerReducer,
        calculator: calculatorReducer,
        myProjects3: myProjects3Reducer,
        sitePortfolio: sitePortfolioReducer,
        elementMatch: elementMatchReducer,
        editUserProduct: editUserProductReducer,
        questionnairePT: questionnairePTReducer
    };

  const middleware = [
    refreshTokenMiddleware(),
    thunk,
    routerMiddleware(history)
  ];

  // In development, use the browser's Redux dev tools extension if installed
  const enhancers = [];
  const isDevelopment = process.env.NODE_ENV === 'development';
  if (isDevelopment && typeof window !== 'undefined' && window.devToolsExtension) {
    enhancers.push(window.devToolsExtension());
  }

  const rootReducer = combineReducers({
    ...reducers,
    router: connectRouter(history),
  });

  return createStore(
    rootReducer,
    initialState,
    compose(
      applyMiddleware(
        ...middleware),
      ...enhancers)
  );
}
const store = configureStore(history, initialState);
export default store;